import { useEffect, useRef, useState } from "react";

/**
 * IntersectionObserverを使ったフェードインアニメーション用フック
 * @param {number} threshold - 表示判定の閾値
 * @return {{ ref: React.RefObject<HTMLDivElement>, isVisible: boolean }} ref と表示状態
 */
export function useFadeIn(threshold = 0.15) {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);

  return { ref, isVisible };
}
